import Vue from 'vue';
import DatePicker from './DatePicker.vue';
import EventDatePicker from './EventDatePicker.vue';

Vue.component('e-date-picker', DatePicker);
Vue.component('event-date-picker', EventDatePicker);
